import React, { useEffect, useState } from 'react';
import ajaxViolation from '../../utils/remote/ajaxViolation';

const CobraReportContext = React.createContext();

export const CobraReportConsumer = CobraReportContext.Consumer;

export const CobraReportProvider = (props)=> {

  const [data, setData] = useState(false)
  const [loading, setLoading] = useState(false);
  const [performanceData, setPerformanceData] = useState(false);
  const [title, setTitle] = useState('');



useEffect(()=>{
  if(data){
    getCobraPerformance()
  }
}, [data])


const getCobraPerformance=async()=>{
    setPerformanceData(false);
    const server_response = await ajaxViolation.fetchCobrasPerformance(data);
    if(server_response.status==='OK'){
        setPerformanceData(server_response.details.content)
        setTitle(server_response.message)

    }else{
        setPerformanceData('404')
    }   
}




const resetData=()=>{
    setData({
        "date_from":'',
        "date_to":'',
    })
}

const filterData=(options)=>{
    setData({
        "date_from":options.dateFrom,
        "date_to":options.dateTo,
    })
    
}

    
    return (
           <CobraReportContext.Provider value={
               {
                  loading,
                  performanceData,
                  title,
                  getCobraPerformance,
                  setData,
                  resetData,
                  filterData
               }
               }>
               {props.children}
           </CobraReportContext.Provider>
        );
    
}

export default CobraReportContext;